import React, { FC, ReactElement, ReactNode } from "react";
import { APP_CONSTANTS } from "kw/util/appConstants";
import { Font } from "baseui/theme";
import { isNullish } from "kanopi-components/utils/primitives";
import { useFormatter, valueTypes } from "../../util/useFormatter";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export type TTwoColumnTable = {
  id: string;
  rows: TTableRow[];
  summary?: TTableRow;
  labelColor?: string;
  rowPadding?: string;
  columnPadding?: string;
  typography?: Font;
  align?: "center" | "left" | "right";
};

export type TTableRow = {
  label: string;
  type?: valueTypes | "Element";
  value: string | boolean | number | Date | ReactElement | undefined;
  element?: ReactNode;
  options?: TRadioOptions[]; // Required when display value is in options[]
};
export const TwoColumnTable: FC<TTwoColumnTable> = ({
  id,
  rows,
  summary,
  rowPadding,
  columnPadding,
  labelColor,
  typography,
  align = "center",
}) => {
  const [css, theme] = useStyletron();
  const { format } = useFormatter();
  const summaryValue = format(summary?.value, summary?.type);
  return (
    <>
      <table
        data-testid={id}
        className={css({
          tableLayout: "auto",
          borderCollapse: "collapse",
          ...(typography || theme.typography.ParagraphMedium),
        })}
        style={{
          marginLeft: align === "left" || align === "center" ? "auto" : "initial",
          marginRight: align === "right" || align === "center" ? "auto" : "initial",
        }}
      >
        <tbody>
          {rows?.length > 0 &&
            rows.map((row, index) => {
              const rowValue = format(
                row.value,
                row?.type,
                APP_CONSTANTS.EMPTY_DISPLAY,
                row?.options
              );
              return (
                <tr
                  key={index}
                  className={css({
                    paddingLeft: theme.sizing.scale600,
                    paddingRight: theme.sizing.scale600,
                  })}
                >
                  <td
                    className={css({
                      width: "50%",
                      paddingBottom: rowPadding || theme.sizing.scale300,
                      paddingTop: rowPadding || theme.sizing.scale300,
                      paddingRight: columnPadding || theme.sizing.scale400,
                      textAlign: "right",
                      color: labelColor || theme.colors.contentTertiary,
                    })}
                  >
                    {row?.label}
                  </td>
                  <td
                    className={css({
                      width: "50%",
                      paddingBottom: rowPadding || theme.sizing.scale300,
                      paddingTop: rowPadding || theme.sizing.scale300,
                      paddingLeft: columnPadding || theme.sizing.scale400,
                    })}
                  >
                    {row.type === "Element" ? row?.element : rowValue}
                  </td>
                </tr>
              );
            })}
          {summary?.label || !isNullish(summary?.value) ? (
            <>
              <tr
                className={css({
                  borderTop: `1px solid ${theme.colors.mono300}`,
                })}
              >
                <td
                  className={css({
                    width: "50%",
                    paddingBottom: rowPadding || theme.sizing.scale300,
                    paddingTop: rowPadding || theme.sizing.scale300,
                    paddingRight: columnPadding || theme.sizing.scale400,
                    textAlign: "right",
                    color: labelColor || theme.colors.contentTertiary,
                    fontWeight: 500,
                  })}
                >
                  {summary?.label}
                </td>
                <td
                  className={css({
                    width: "50%",
                    paddingBottom: rowPadding || theme.sizing.scale300,
                    paddingTop: rowPadding || theme.sizing.scale300,
                    paddingLeft: columnPadding || theme.sizing.scale400,
                    fontWeight: 500,
                  })}
                >
                  {summaryValue}
                </td>
              </tr>
            </>
          ) : (
            <></>
          )}
        </tbody>
      </table>
    </>
  );
};
